module.exports = __webpack_public_path__ + "static/media/cloud-upload-purple.9459c65f.svg";